import React from "react";
import styled from "styled-components";
import twoBedroom from "../assets/2-bed.png";
import threeBedroom from "../assets/3-bed.png";
import penthouse from "../assets/landscape.jpeg";
import Gallery from "../components/Gallery";

const PageContainer = styled.div`
  padding-top: 120px; // Space for fixed header
`;

const ApartmentContainer = styled.div`
  max-width: 1100px;
  margin: 40px auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    margin: 20px auto;
  }
`;

const PageTitle = styled.h2`
  text-align: center;
  color: #145757;
  margin-bottom: 30px;
  font-size: 2.2rem;
`;

const ApartmentCard = styled.div`
  background: white;
  border-radius: 10px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ApartmentImage = styled.div`
  flex: 1 1 300px;
  max-width: 400px;
  overflow: hidden;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const ApartmentDetails = styled.div`
  flex: 2;
  padding: 20px;
`;

const ApartmentTitle = styled.h3`
  color: #145757;
  margin-top: 0;
`;

const ApartmentDescription = styled.p`
  line-height: 1.6;
`;

const ApartmentStats = styled.p`
  margin-top: 20px;
`;

const ApartmentsPage = () => {
  return (
    <PageContainer>
      <ApartmentContainer>
        <PageTitle>Our Apartments</PageTitle>

        <ApartmentCard>
          <ApartmentImage>
            <Image src={twoBedroom} alt="2 Bedroom Apartment" />
          </ApartmentImage>
          <ApartmentDetails>
            <ApartmentTitle>2 Bedroom Apartment</ApartmentTitle>
            <ApartmentDescription>
              Perfect for families, our spacious 2-bedroom apartments feature a
              modern open-concept living area, contemporary kitchen with premium
              appliances, two well-appointed bedrooms with built-in wardrobes,
              and a private balcony offering panoramic views of the Galiyat
              mountains.
            </ApartmentDescription>
            <ApartmentStats>
              <strong>Area:</strong> 1739 sq ft &nbsp; | &nbsp;{" "}
              <strong>Status:</strong> Available
            </ApartmentStats>
          </ApartmentDetails>
        </ApartmentCard>

        <ApartmentCard>
          <ApartmentImage>
            <Image src={threeBedroom} alt="3 Bedroom Apartment" />
          </ApartmentImage>
          <ApartmentDetails>
            <ApartmentTitle>3 Bedroom Apartment</ApartmentTitle>
            <ApartmentDescription>
              Our premium 3-bedroom apartments offer luxurious living with
              spacious rooms, elegant finishes, and modern amenities. Each unit
              features a large living area, gourmet kitchen, three master
              bedrooms with en-suite bathrooms, and a private terrace perfect
              for enjoying the stunning mountain views.
            </ApartmentDescription>
            <ApartmentStats>
              <strong>Area:</strong> 2072 sq ft &nbsp; | &nbsp;{" "}
              <strong>Status:</strong> Available
            </ApartmentStats>
          </ApartmentDetails>
        </ApartmentCard>

        <ApartmentCard>
          <ApartmentImage>
            <Image src={penthouse} alt="Penthouse Suite" />
          </ApartmentImage>
          <ApartmentDetails>
            <ApartmentTitle>Penthouse Suite</ApartmentTitle>
            <ApartmentDescription>
              Experience the pinnacle of luxury living in our exclusive
              penthouse suite. Featuring premium finishes, private elevator
              access, a rooftop terrace with panoramic views, and bespoke
              amenities designed for the most discerning residents.
            </ApartmentDescription>
            <ApartmentStats>
              <strong>Area:</strong> 2500 sq ft &nbsp; | &nbsp;{" "}
              <strong>Status:</strong> Sold Out
            </ApartmentStats>
          </ApartmentDetails>
        </ApartmentCard>
      </ApartmentContainer>

      <Gallery />
    </PageContainer>
  );
};

export default ApartmentsPage;
